/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, type SerializedStyles } from '@emotion/react';

import type { TokenColumnWidth } from '../types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const tableTokenColumnWidthStyles: Record<TokenColumnWidth, SerializedStyles> = {
	medium: css({ minWidth: '5rem', maxWidth: '5rem' }),
	large: css({ minWidth: '8.75rem', maxWidth: '8.75rem' }),
	'extra-large': css({ minWidth: '11rem', maxWidth: '11rem' }),
};
